export enum RoutersEnum {
    WebRequestFormPage = '/web-request-form',
    ClientConsultGR = '/clients-consult-gr',
    formMultiProducts = '/form-multiproducts',
    ClientConsulMultiProducts = '/clients-consult-multiproducts',

}